<template>
  <div class="page-wrapper">
    <div class="container">
      <!-- content -->
      <div class="content">
        <BaseLoading  :spinning="favouritesLoading" size="large">
          <!-- search-content -->
          <div class="search-content text-uppercase">
            <h2>Favorite {{ this.routeName.split("_").join(" ") }} List</h2>
          </div>
          <div
            class="favourites-content-wrapper"
            v-if="favourites.length !== 0"
          >
            <div
              class="favourite-content"
              v-for="(item, index) in favourites"
              :key="index"
            >
              <a-row :gutter="[42, 24]">
                <a-col :sm="2">
                  <BaseButton
                    type="link"
                    size="large"
                    class="icon-filled"
                    @click="handleFavouriteClick(item)"
                  >
                    <BaseIcon type="star" theme="filled" size="40" />
                  </BaseButton>
                </a-col>
                <a-col :sm="3">
                  <BaseImageWrapper
                    wrapper-style="circle"
                    :name="item.name"
                    :image-url="
                      generateImageUrl(
                        item.imageUrl ||
                          item.profileImage ||
                          item.image ||
                          item.logo
                      )
                    "
                    :size="75"
                  />
                </a-col>
                <a-col :sm="15">
                  <div class="favourite-information-wrapper">
                    <h2 @click="handleNameClick(item)" class="pointer-hover">
                      {{ item.title }}
                    </h2>
                    <div :class="item.title ? '' : 'black-bold'">
                      <p v-if="collegeEvent">
                        {{ item.collegeId && item.collegeId.collegeName }}
                      </p>
                      <p v-else-if="clubEvent">
                        {{ item.clubId && item.clubId.clubName }}
                      </p>
                      <h2
                        @click="handleNameClick(item)"
                        class="pointer-hover"
                        v-else
                      >
                        {{ item.name }}
                      </h2>
                    </div>

                    <p v-if="collegeEvent || clubEvent">
                      {{ item.date ? ` ${item.date}` : "" }}
                      {{
                        item.time &&
                        String(new Date(item.time)) === "Invalid Date"
                          ? getTime(item.time)
                          : $options.filters.dateToTime(new Date(item.time))
                      }}
                      {{ item.location ? `, ${item.location}` : "" }}
                      {{ item.city ? ` ${item.city}` : "" }}
                      {{ item.state ? `, ${item.state}` : "" }}
                    </p>
                    <p v-else>
                      {{ item.date }}
                      {{ item.location ? `, ${item.location}` : "" }}
                      {{ item.city ? ` ${item.city}` : "" }}
                      {{ item.state ? `, ${item.state}` : "" }}
                    </p>
                    <p v-if="item.division">Division: {{ item.division }}</p>
                    <p v-if="item.age">AgeGroup: {{ item.age }}</p>
                    <p v-if="item.graduationYear">
                      Graduation Year: {{ item.graduationYear }}, GPA:
                      {{ item.gpa }}
                    </p>
                  </div>
                </a-col>
                <a-col :sm="4"
                  ><span
                    v-if="collegeEvent || clubEvent"
                    class="black-bold italics"
                    >Event Type: {{ item.eventType }}</span
                  >
                </a-col>
              </a-row>
            </div>
          </div>
        </BaseLoading>
      </div>
    </div>
  </div>
</template>

<script>
import { Favourite } from "@/models";
import { mapGetters } from "vuex";
import resourceNamePluralizer from "@/utils/resource-name-pluralizer";
import camelCase from "lodash/camelCase";

const FAVOURITE_STORE_KEY = "favouriteStore";

export default {
  data() {
    return {
      resourcePluralizer: resourceNamePluralizer
    };
  },
  props: {
    collegeEvent: {
      type: Boolean,
      default: false
    },
    clubEvent: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.dispatcher(camelCase(this.routeName));
  },
  computed: {
    ...mapGetters({
      favourites: `${FAVOURITE_STORE_KEY}/favourites`,
      favouritesLoading: `${FAVOURITE_STORE_KEY}/favouritesLoading`
    }),
    routeName() {
      const routes = this.$route.path.split("/");
      return routes[routes.length - 1];
    }
  },
  methods: {
    async handleFavouriteClick(item) {
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
        favBy: Favourite.profileId(),
        favTo: item.Id
      });
      await this.$store.dispatch(
        `${FAVOURITE_STORE_KEY}/deleteLocalFavouriteDate`,
        {
          id: item.Id
        }
      );
    },
    getTime(time) {
      if (time) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let hours = hour % 12 || 12;
        let AmOrPm = hour >= 12 ? "PM" : "AM";
        return `${hours}:${min} ${AmOrPm}`;
      }
      return "";
    },
    handleNameClick(item) {
      if (this.routeName === "college") {
        this.$router.push(
          `/${this.$route.params.profileId}/college_profile/${item.Id}/summary`
        );
      } else if (this.routeName === "club_team") {
        this.$router.push(
          `/${this.$route.params.profileId}/club_profile/${item.Id}/summary`
        );
      } else if (this.routeName === "college_event") {
        this.$router.push(
          `/${this.$route.params.profileId}/college/${item.collegeId.Id}/event/${item.Id}`
        );
      } else if (this.routeName === "club_event") {
        this.$router.push(
          `/${this.$route.params.profileId}/club/${item.clubId.Id}/event/${item.Id}`
        );
      } else if (this.routeName === "athlete") {
        this.$router.push(
          `/${this.$route.params.profileId}/athlete/${item.Id}/summary`
        );
      }
    },
    async dispatcher(slug) {
      let playerProfileId = "";
      if (JSON.parse(localStorage["user-permissions"]) === "player")
        playerProfileId = Favourite.profileId();
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/getFavourites`, {
        slug,
        profileId: Favourite.profileId(),
        playerProfileId
      });
    }
  },
  watch: {
    routeName: {
      immediate: true,
      handler: function(newVal, _) {
        this.dispatcher(camelCase(newVal));
      }
    }
  }
};
</script>

<style lang="sass">
.favourites-content-wrapper
  &:last-child
    border-bottom: 1px solid lightgrey
  .favourite-content
    border-top: 1px solid lightgrey
    padding: 15px  0
    align-items: center
    .favourite-information-wrapper
      h2, p
        margin: 0 !important
        text-transform: capitalize
      h2
        margin-bottom: .4rem !important
      p
        color: black

@media only screen and (max-width: 575px)
  .favourites-content-wrapper
    .favourite-content
      .ant-row
        .ant-col
          display: flex
          justify-content: center
      .favourite-information-wrapper
        text-align: center
        padding: 20px 0
</style>
